export default __webpack_public_path__ + "static/media/social-media-manager.280a4c39.jpg";